/**
 * The rejection report's confirmation, sheet 23 callout 10 (mission 6 WP10
 * T054; FR-021, FR-027; ANA.11, ANA.7, ANA.9, T.3, X.9).
 *
 * The report number in mono, which receives focus on mount so the modal never
 * drops focus to the page; then register 14's "what happens next" and "what
 * Bloom will not do" (the only entry with `ceilingReviewed`, CLAUDE.md §3.6).
 * One primary close action. Nothing of the 201 is kept but the number.
 *
 * Mission 7 WP11 (T061; FR-017; sheet 23 callout 10): a link to the run's
 * transmission log (`viewTransmissionLog`, `/app/runs/:id/transmissions`).
 */
import { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { DialogBody, DialogFooter } from '@/components/ui/dialog'
import { Mono } from '@/lib/format'
import { copyText } from '@/lib/provisional-copy'

export interface RejectionConfirmationProps {
  /** `RR-000123`. */
  reportNumber: string
  runId: string
  onClose(): void
}

export function RejectionConfirmation({ reportNumber, runId, onClose }: RejectionConfirmationProps) {
  const first = useRef<HTMLParagraphElement>(null)
  useEffect(() => {
    first.current?.focus()
  }, [])

  return (
    <>
      <DialogBody className="flex flex-col gap-4">
        <p
          ref={first}
          tabIndex={-1}
          className="self-start rounded-sm text-h3 text-navy-950 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
        >
          <Mono>{reportNumber}</Mono>
        </p>
        <p className="text-body text-navy-950">{copyText('whatHappensNext')}</p>
        <p className="text-body text-navy-950">{copyText('whatBloomWillNotDo')}</p>
        <p>
          <Link
            to={`/app/runs/${encodeURIComponent(runId)}/transmissions`}
            className="text-body text-[var(--color-link)] underline-offset-4 hover:text-[var(--color-link-hover)] hover:underline"
          >
            {copyText('viewTransmissionLog')}
          </Link>
        </p>
      </DialogBody>
      <DialogFooter>
        <Button onClick={onClose}>{copyText('confirmationClose')}</Button>
      </DialogFooter>
    </>
  )
}
